import React, { useEffect, useState, useContext, useCallback } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Card, CardHeader, CircularProgress, Box } from "@mui/material";
import AccountingApi from "../../Classes/API/AccountingApi";
import DataTable from "examples/Tables/DataTable";
import Pagination from "@mui/material/Pagination";
import MDBox from "components/MDBox";
import Swal from "sweetalert2";
import MDTypography from "components/MDTypography";
import { useNavigate } from "react-router-dom";
import LogsSearch from "./LogsSearch";
import SearchLogsReq from "../../Classes/Models/Requests/Accounting/SearchLogsReq";
import { LanguageContext } from "App";
import Loader from "Loader";
const Index = () => {
  let navigate = useNavigate();

  const [SearchReq, setSearchReq] = useState(new SearchLogsReq());
  const [TableDataRows, setTableDataRows] = useState([]);
  const [Page, setPage] = useState(1);
  const [TotalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const { translations } = useContext(LanguageContext);
  const TableColumns = [
    {
      Header: "Log ID",
      accessor: "Id",
      align: "left",
    },
    {
      Header: "Accounting Session ID",
      accessor: "AccSessionID",
      align: "left",
    },
    {
      Header: "Patient Name",
      accessor: "PatientName",
      align: "left",
    },
    {
      Header: translations.LogsSearchtablType,
      accessor: "Type",
      align: "left",
    },
    {
      Header: "Staff Name",
      accessor: "User",
      align: "left",
    },
    {
      Header: translations.LogsSearchMessage,
      accessor: "Message",
      align: "left",
    },
    {
      Header: translations.LogsSearchtableTime,
      accessor: "Time",
      align: "left",
    },
    {
      Header: translations.LogsSearchResponse,
      accessor: "Response",
      align: "left",
    },
  ];

  const MakeTableRow = (log) => {
    const formatDateTime = (dateString) => {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleString();
    };

    return {
      Id: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.id}
        </MDTypography>
      ),
      AccSessionID: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.accSessionId ? log.accSessionId : "N/A"}
        </MDTypography>
      ),
      PatientName: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.patientName ? log.patientName : "N/A"}
        </MDTypography>
      ),
      Type: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.logType}
        </MDTypography>
      ),
      User: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.userName}
        </MDTypography>
      ),
      Message: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.message}
        </MDTypography>
      ),
      Time: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {formatDateTime(log.date)}
        </MDTypography>
      ),
      Response: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.response}
        </MDTypography>
      ),
    };
  };

  const onSearch = async (pageNumber = Page) => {
    setLoading(true);

    const req = { ...SearchReq };

    req.pagingParams = {
      pageNumber: pageNumber,
      pageSize: 10,
    };

    try {
      let res = await AccountingApi.SearchLogs(req);
      if (res.status === "Success") {
        setTotalPages(res.data.totalPages);

        const rows = res.data.list.map((entry) => MakeTableRow(entry));
        setTableDataRows(rows);
      } else {
        Swal.fire({ icon: "error", text: res.message });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    onSearch();
  }, [SearchReq, Page]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <LogsSearch setSearchReq={setSearchReq} setPage={setPage} />
      {loading ? (
        <Loader />
      ) : (
        <Card className="mt-5">
          <MDBox
            mt={-3}
            py={3}
            px={2}
            bgColor="info"
            coloredShadow="info"
            sx={{
              borderTopLeftRadius: "1.1rem",
              borderTopRightRadius: "1.1rem",
              backgroundColor: "#3560AD",
            }}
          >
            <div className="text-center">
              <MDTypography variant="h6" color="white">
                {translations.LogsSearchtablLogs}
              </MDTypography>
            </div>
          </MDBox>

          <DataTable
            table={{ columns: TableColumns, rows: TableDataRows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />

          <div className="text-right mx-3 my-4">
            <Pagination
              count={TotalPages}
              page={Page}
              color="primary"
              onChange={(e, num) => setPage(num)}
              className="float-right"
            />
          </div>
        </Card>
      )}
    </DashboardLayout>
  );
};

export default Index;
